import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	sectionTitle: {
		id: 'spa-apps-sidebar-core.multi-project-menu.projects-header.one-click-project.template-picker.section-title',
		defaultMessage: 'Start a new project',
		description: 'Section title for project create template picker.',
	},
	moreTemplatesButtonText: {
		id: 'spa-apps-sidebar-core.multi-project-menu.projects-header.one-click-project.template-picker.more-templates-button-text',
		defaultMessage: 'More templates',
		description: 'Text of button that allows to see all available project templates.',
	},
	importButtonText: {
		id: 'spa-apps-sidebar-core.multi-project-menu.projects-header.one-click-project.template-picker.import-button-text',
		defaultMessage: 'Import',
		description: 'Text of button that directs user to import project screen.',
	},
	lastCreated: {
		id: 'spa-apps-sidebar-core.multi-project-menu.projects-header.one-click-project.template-picker.last-created',
		defaultMessage: 'Last created',
		description: 'Label for last created template lozenge',
	},
});
